import logo from "../../assets/images/logo.png";
import avatar from "../../assets/images/avatar.png";
import developerAvatar from "../../assets/images/dev.jpg";
import marketingAvatar from "../../assets/images/fefdy.png";
import reportIcon from "../../assets/images/SVG/report.svg";
import certificateIcon from "../../assets/images/SVG/certificate.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

import { useAuth } from "../../context/AuthContext";
import CustomLanguageDropdown from "./CustomLanguageDropdown";
import CertificateModal from "../../pages/certificate/index";

import useFetchProfile from "../../hooks/useFetchProfile";

import "./style.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

import useSubjectsFetch from "../../hooks/useFetchSubjects";

function HeaderComponent({ handleClick }) {
  const [profile] = useFetchProfile();
  const [isCertificateModalOpen, setIsCertificateModalOpen] = useState(false);

  const navigate = useNavigate();
  const { breadcrumbs, setBreadcrumbs, logout, auth, setCommonWarning } =
    useAuth();
  const userData = auth.user ? auth.user : {};

  const userRole = userData?.role?.toLowerCase();

  const profileImage =
    userRole === "developer"
      ? developerAvatar
      : userRole === "marketing"
        ? marketingAvatar
        : null;


  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const handleBreadcrumbClick = (index) => {
    const trimmedBreadcrumbs = breadcrumbs.slice(0, index + 1);
    setBreadcrumbs(trimmedBreadcrumbs);
    navigate(breadcrumbs[index].path);
  };

  const handleHomeClick = () => {
    setBreadcrumbs([]);
    navigate("/");
  };

  const location = useLocation();

  useEffect(() => {
    setBreadcrumbs((prevBreadcrumbs) => {
      const currentIndex = prevBreadcrumbs.findIndex(
        (item) => item.path === location.pathname,
      );

      if (currentIndex === -1) {
        // Optionally add the current page, or just keep existing breadcrumbs
        return [];
      } else if (currentIndex !== prevBreadcrumbs.length - 1) {
        // Trim breadcrumbs to current
        return prevBreadcrumbs.slice(0, currentIndex + 1);
      }

      return prevBreadcrumbs; // No change needed
    });
  }, [location.pathname, setBreadcrumbs]);


  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const toggleDropdown = () => setDropdownOpen((prev) => !prev);
  // const handleProfileClick = () => {
  //   navigate("/profile");
  // };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    // Check if script is already added
    const existingScript = document.querySelector(
      'script[src="https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"]',
    );

    // Check if Google Translate element is already initialized
    const existingElement = document.getElementById("google_translate_element");
    localStorage.LanguageCode = "en";

    // Prevent duplicate script + translator UI
    if (
      !existingScript &&
      existingElement &&
      existingElement.innerHTML === ""
    ) {
      const script = document.createElement("script");
      script.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;

      script.onload = () => {
        // Ensure the translation element is initialized only once
        window.googleTranslateElementInit = () => {
          if (window.google && window.google.translate) {
            try {
              new window.google.translate.TranslateElement(
                { pageLanguage: "en", includedLanguages: "en,ta,te,ml,hi" },
                "google_translate_element",
              );
            } catch (error) {
              console.error("Error initializing Google Translate:", error);
            }
          } else {
            console.warn("Google Translate API is not available.");
          }
        };

        // If the script loaded but init is not available yet, call the init function
        if (window.google && window.google.translate) {
          window.googleTranslateElementInit();
        } else {
          console.warn("Google Translate failed to load properly.");
        }
      };

      script.onerror = () => {
        console.warn("Failed to load Google Translate script.");
      };

      document.body.appendChild(script);
    }
  });

  const [subjects, loading] = useSubjectsFetch();

  return (
    <>
      <div className="header">
        <div className="header-top">
          <div className="logo">
            <a href="/">
              <img src={logo} alt="Fefdy BrainGym Logo" />
            </a>
          </div>
          <div className="header-right">
            <div
              className="reports-icon tooltip"
              onClick={() =>
                handleClick(1, "Overall report", `/overall-report`)
              }
            >
              <img src={reportIcon} alt="Reports" />
            </div>

            <div
              className="certificate-icon c-tooltip"
              onClick={() => setIsCertificateModalOpen(true)}
              style={{ cursor: "pointer" }}
            >
              <img src={certificateIcon} alt="Certificate" />
            </div>

            {/* <div className="search-container">
              <div className="search-icon">
                <svg viewBox="0 0 24 24" fill="none">
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="m21 21-4.35-4.35"></path>
                </svg>
              </div>
              <input
                type="text"
                className="search-input"
                placeholder="Search here...."
              />
              <div className="back-btn">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </div>
            </div> */}

            {/* Replace the old language dropdown with custom component */}
            <CustomLanguageDropdown />
            {profile.map((profile, index) => (
              <div className="user-profile" key={profile.id} ref={dropdownRef}>
                <div className="avatar" onClick={toggleDropdown}>
                  <img
                    src={profileImage || profile.image || avatar}
                    alt="User avatar"
                  />
                </div>
                <div className="user-info" onClick={toggleDropdown}>
                  <div className="username">{userData?.name}</div>
                  <div className="email">{userData?.email}</div>
                </div>
                <span className="user-dropdown" onClick={toggleDropdown}>
                  <FontAwesomeIcon icon={faChevronDown} />
                </span>

                {dropdownOpen && (
                  <div className="profile-dropdown">
                    <div
                      className="dropdown-item"
                      onClick={() =>
                        handleClick(profile.id, profile.name, `/profile`)
                      }
                    >
                      Profile
                    </div>
                    <div className="dropdown-item" onClick={logout}>
                      Logout
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="breadcrumbs-wrapper">
          <div className="breadcrumbs">
            <span onClick={handleHomeClick} style={{ cursor: "pointer" }}>
              Home
            </span>
            {breadcrumbs.map((crumb, index) => (
              <span key={crumb.path}>
                <FontAwesomeIcon
                  icon={faChevronRight}
                  style={{ margin: "0 5px" }}
                />
                {index === breadcrumbs.length - 1 ? (
                  <span>{capitalizeFirstLetter(crumb.title)}</span>
                ) : (
                  <span
                    onClick={() => {
                      localStorage.setItem("sub_complete_modal_show", "true");
                      handleBreadcrumbClick(index);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {capitalizeFirstLetter(crumb.title)}
                  </span>
                )}
              </span>
            ))}
          </div>
        </div>
      </div>
      {/* Certificate Modal */}
      <CertificateModal
        isOpen={isCertificateModalOpen}
        onClose={() => setIsCertificateModalOpen(false)}
        subjects={subjects}
        auth={auth}
        setCommonWarning={setCommonWarning}
        navigate={navigate}
      />
    </>
  );
}

export default HeaderComponent;
